import { RevenueIcon, ChartIcon, PlayIcon, CalendarIcon, GridIcon, SparkIcon } from './icons';

/**
 * Overview — the dashboard Bobby will use to see the brand's numbers. Stubbed
 * cards for now; each gets wired to its real data source over time.
 */
const CARDS = [
  { icon: <RevenueIcon />, title: 'Revenue', value: '—', note: 'Merch, streams & Stripe' },
  { icon: <PlayIcon />, title: 'YouTube', value: '—', note: 'Views, subs & watch time' },
  { icon: <ChartIcon />, title: 'Google Analytics', value: '—', note: 'Site traffic & sources' },
  { icon: <SparkIcon />, title: 'Insights', value: '—', note: 'Cross-platform reach' },
  { icon: <CalendarIcon />, title: 'Schedule', value: '—', note: 'Upcoming posts & drops' },
  { icon: <GridIcon />, title: 'Content', value: '—', note: 'Posts published' },
];

export function OverviewPage() {
  return (
    <div className="page-overview">
      <header className="ph">
        <h1 className="ph__title">Overview</h1>
      </header>
      <div className="statcards">
        {CARDS.map((c) => (
          <section className="statcard" key={c.title}>
            <div className="statcard__head">
              <span className="statcard__icon">{c.icon}</span>
              <span className="statcard__title">{c.title}</span>
            </div>
            <div className="statcard__value">{c.value}</div>
            <div className="statcard__note">{c.note}</div>
            <span className="statcard__soon">Coming soon</span>
          </section>
        ))}
      </div>
    </div>
  );
}
